import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'

const propTypes = {
  isOrderCancelable: PropTypes.bool
}

/**
 * To give nice look on `bank_transfer_payment.expires_at`
 * It maps to certain style and pass to `StatusBadge`.
 * @param {boolean} isOrderCancelable payment bank transfer is_order_cancelable value
 */
const IsOrderCancelableBadge = ({ isOrderCancelable }) => {

  const color = isOrderCancelable ? 'primary' : 'info'
  const label = isOrderCancelable ? 'Yes' : 'No'

  return <StatusBadge color={ color } label={ label } />
}

IsOrderCancelableBadge.propTypes = propTypes

export default IsOrderCancelableBadge
